import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const virtualAgentIntentsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtual-agent-intents',
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents',
	exact: true,
};
